"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFactor = void 0;
var FormFactor;
(function (FormFactor) {
    FormFactor["DESKTOP"] = "Desktop";
    FormFactor["MOBILE"] = "Mobile";
})(FormFactor = exports.FormFactor || (exports.FormFactor = {}));
//# sourceMappingURL=environment.const.js.map